import { render, staticRenderFns } from "./_copyLinkButton.vue?vue&type=template&id=740d6ffe&"
import script from "./_copyLinkButton.vue?vue&type=script&lang=js&"
export * from "./_copyLinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('740d6ffe', component.options)
    } else {
      api.reload('740d6ffe', component.options)
    }
    module.hot.accept("./_copyLinkButton.vue?vue&type=template&id=740d6ffe&", function () {
      api.rerender('740d6ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/ActionToolbar/Scripts/Buttons/_copyLinkButton.vue"
export default component.exports